import { createSlice } from "@reduxjs/toolkit";
import {
  InventorySuppliersType
} from "../../features/finance-inventory-module/data-handling/finance-inventory-types";
import { userNormalLogout, supportLogout } from "../actions";

export interface InventoryState {
  inventorySupplierData: InventorySuppliersType[]
}

const initialState: InventoryState = {
  inventorySupplierData: []
};

export const inventorySlice = createSlice({
  name: "inventory",
  initialState,
  reducers: {
    getFilteredInventoryActivity: (state, action) => { },
    getActivityDetail: (state, action) => { },
    saveActivityDetail: (state, action) => { },
    submitActivityDetail: (state, action) => { },
    getRelatedInventoryActivity: (state, action) => { },
    uploadActivityAttachment: (state, action) => { },
    attachmentDownloadDelete: (state, action) => { },
    activityPostFinalEdit: (state, action) => { },
    getInventorySupplierFetchAll: (state, action) => { },
    inventorySupplierData: (state, action) => {
      state.inventorySupplierData = action.payload || [];
    },
    bulkApprovalSubmit: (state, action) => { },
    rejectActivityDetail: (state, action) => { }
  },
  extraReducers: (builder) => {
    builder
      .addCase(userNormalLogout, () => initialState)
      .addCase(supportLogout, () => initialState);
  },
});

export const {
  getFilteredInventoryActivity,
  getActivityDetail,
  saveActivityDetail,
  submitActivityDetail,
  getRelatedInventoryActivity,
  uploadActivityAttachment,
  attachmentDownloadDelete,
  activityPostFinalEdit,
  getInventorySupplierFetchAll,
  inventorySupplierData,
  bulkApprovalSubmit,
  rejectActivityDetail
} = inventorySlice.actions;

export default inventorySlice.reducer;
